<template>
  <div data-cc="read-only-input">
    <div
      class="text-body-2 font-weight-bold text-capitalize"
      data-cc="read-only-input-label"
    >
      {{ label }}
    </div>
    <div
      class="text-break"
      :class="{ multiline: multiline }"
      data-cc="read-only-input-value"
    >
      {{ model }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  model: string | number;
  multiline?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.multiline {
  white-space: pre-wrap;
}
</style>
